import React from "react";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import "../Subscribe/SubscribePage.css"; // reuse your nice styling

function PublicPlansPage() {
  const navigate = useNavigate();

  const benefits = [
    "Health AI assistant",
    "Behavior AI coaching",
    "Document storage",
    "Vet reminders",
    "Lost pet alert system",
    "Recovery dashboard",
    "QR scan history",
    "Pet profile",
    "Personalized nutrition & care advice",
    "Symptom checking guidance",
    "24/7 AI support",
  ];

  const SubscriptionBenefits = () => (
    <div className="subscribe-benefits-card mt-4">
      <h5 className="mb-2">Your subscription includes:</h5>
      <p className="text-muted small mb-3">
        We’re rolling these out in phases. Some features will start simple and
        grow more powerful over time — all included in your plan.
      </p>
      <div className="row">
        {benefits.map((item) => (
          <div
            key={item}
            className="col-12 col-sm-6 mb-2 d-flex align-items-start"
          >
            <span className="me-2 mt-1">✅</span>
            <span className="small">{item}</span>
          </div>
        ))}
      </div>
    </div>
  );

  return (
    <div className="subscribe-wrapper">
      <div className="subscribe-shell">
        <header className="subscribe-header">
          <div className="subscribe-header-text">
            <h4 className="subscribe-title">Household plans</h4>
            <p className="subscribe-subtitle mb-0">
              One subscription powers SmartTag AI and safety tools for your pets.
            </p>
          </div>
          {/* No status pill on public page */}
        </header>

        <div className="subscribe-body">
          <div className="d-flex flex-column align-items-center">
            <h2 className="mb-3">Choose your household plan</h2>
            <p
              className="text-muted mb-4 text-center"
              style={{ maxWidth: 520 }}
            >
              Your subscription unlocks SmartTag AI and tools to keep your pets
              safe, healthy, and easy to recover. One plan can cover all
              SmartTags in your household.
            </p>

            <div className="subscribe-plans-row d-flex gap-3 flex-wrap justify-content-center">
              {/* Starter – 2 pets */}
              <div className="card p-3" style={{ minWidth: 220 }}>
                <h4 className="mb-1">Starter</h4>
                <p className="mb-1">$4.99 / month</p>
                <p className="small text-muted mb-2">Up to 2 pets</p>
                <Button
                  className="lpp-pill-btn"
                  onClick={() => navigate("/login")}
                >
                  Get started with Starter
                </Button>
              </div>

              {/* Family – 5 pets */}
              <div className="card p-3 border-success" style={{ minWidth: 220 }}>
                <h4 className="mb-1">Family</h4>
                <p className="mb-1">$7.99 / month</p>
                <p className="small text-muted mb-1">Up to 5 pets</p>
                <small className="text-success d-block mb-2">Most popular</small>
                <Button
                  className="lpp-pill-btn"
                  onClick={() => navigate("/login")}
                >
                  Get started with Family
                </Button>
              </div>

              {/* Unlimited – household */}
              <div className="card p-3" style={{ minWidth: 220 }}>
                <h4 className="mb-1">Unlimited</h4>
                <p className="mb-1">$9.99 / month</p>
                <p className="small text-muted mb-2">Entire household</p>
                <Button
                  className="lpp-pill-btn-outline"
                  onClick={() => navigate("/login")}
                >
                  Get started with Unlimited
                </Button>
              </div>
            </div>

            <SubscriptionBenefits />

            <small className="text-muted mt-3 text-center">
              You&apos;ll create a free Little Paws Place account before
              subscribing. You can manage or cancel your subscription anytime.
            </small>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PublicPlansPage;
